import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import './Layout.css'; // File CSS untuk styling layout

function MainLayout() {
  return (
    <div className="app-layout">
      <Header />
      <div className="app-body">
        <Sidebar />
        <main className="app-content">
          <Outlet /> {/* Di sinilah konten halaman akan dirender */}
        </main>
      </div>
      <Footer />
    </div>
  );
}

export default MainLayout;